import React from 'react';
import { Link } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Gr8piFormattedDate } from '../../components/Gr8piFormattedDateTime';

const messages = defineMessages({
  header: { id: 'transfers.detail.header', defaultMessage: 'Transfer details' },
  from: { id: 'transferrs.data_table.headers.transferFrom', defaultMessage: 'Transfer from' },
  to: { id: 'transferrs.data_table.headers.transferTo', defaultMessage: 'Transfer to' },
  amount: { id: 'transferrs.data_table.headers.transfered', defaultMessage: 'Transfered' },
  transferredBy: { id: 'transferrs.data_table.headers.transferedBy', defaultMessage: 'Transfered by' },
  reason: { id: 'transferrs.data_table.headers.transferReason', defaultMessage: 'Reason' },
  transferedOn: {
    id: 'transferrs.account_consumption.data_table.headers.transferedOn',
    defaultMessage: 'Transfered on',
  },
  dataNotAvailable: {
    id: 'consumption.account_consumption.data_table.body.dataNotAvailable',
    defaultMessage: 'Data not available',
  },
});

const ConsumptionDetail = ({ data, currentAccount, locale }) => {
  const { formatMessage } = useIntl();

  const { account } = data;
  const { transfer } = account;
  const { id: transferId, fromAccount, toAccount, amount, transferredBy, transferReason, transactionTime } = transfer;
  const formatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 2 });

  const fromAccountDisplayName = fromAccount ? fromAccount.displayName : formatMessage(messages.dataNotAvailable);
  const toAccountDisplayName = toAccount ? toAccount.displayName : formatMessage(messages.dataNotAvailable);

  const getTransferredByTemplate = () => {
    if (transferredBy) {
      return (
        <Link to={`/accounts/${currentAccount}/users/${transferredBy.id}`}>
          {`${transferredBy.firstName} ${transferredBy.lastName}`}
        </Link>
      );
    }

    return <span>{formatMessage(messages.dataNotAvailable)}</span>;
  };

  const transferredByTemplate = getTransferredByTemplate();

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel header={messages.header.defaultMessage}>
            <div className="p-grid">
              <div className="p-col-12">
                <p>
                  <FormattedMessage id="transfer.id" defaultMessage="ID" tagName="strong" />
                  <span>
                    {': '}
                    {transferId}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.data_table.headers.transferFrom"
                    defaultMessage="Transfer from"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {fromAccountDisplayName}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.data_table.headers.transferTo"
                    defaultMessage="Transfer to"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {toAccountDisplayName}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.data_table.headers.transfered"
                    defaultMessage="Transfered"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {formatter.format(amount)}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.data_table.headers.transferedBy"
                    defaultMessage="Transfered by"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {transferredByTemplate}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.data_table.headers.transferReason"
                    defaultMessage="Reason"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {transferReason}
                  </span>
                </p>
                <p>
                  <FormattedMessage
                    id="transferrs.account_consumption.data_table.headers.transferedOn"
                    defaultMessage="Transfered on"
                    tagName="strong"
                  />
                  <span>
                    {': '}
                    {transactionTime && <Gr8piFormattedDate dateValue={transactionTime} />}
                  </span>
                </p>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
};

ConsumptionDetail.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  locale: PropTypes.string.isRequired,
};

export default ConsumptionDetail;
